import { Button } from '@chakra-ui/react';
import { isBefore } from 'date-fns';
import { FC } from 'react';

import { AddToCalendarSession } from '@/components/ui/shared/buttons/AddToCalendar/AddToCalendarSession';
import { IAddToCalendarSessions } from '@/components/ui/shared/buttons/AddToCalendar/type';

export const AddToCalendarSessionButton: FC<IAddToCalendarSessions> = (props) => {
  const isFinished = isBefore(new Date(props.session.endsAt), new Date());

  if (isFinished) return null;

  return (
    <Button px={0} colorScheme="grey" variant="outline" size="sm" backgroundColor="white" mr="4">
      <AddToCalendarSession {...props} />
    </Button>
  );
};
